import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';     
import adminReducer from './slices/adminSlice';
import adminjobReducer from './slices/adminJobSlice';
import adminApplicationReducer from './slices/adminApplicationSlice';
import adminBidReducer from './slices/adminBidSlice';
import adminSubscriptionReducer from './slices/adminSubscriptionSlice';
import adminReviewReducer from './slices/adminReviewSlice'
import promoCodeReducer from './slices/promoCodeSlice'
import reportingReducer from './slices/reportingSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    admin: adminReducer,
    adminJob: adminjobReducer,
    adminApplication: adminApplicationReducer,
    adminBid: adminBidReducer,
    adminSubscription: adminSubscriptionReducer,
    adminReview: adminReviewReducer,
    promoCode: promoCodeReducer,
    reporting: reportingReducer,
  },
});

export default store;
